import { render, staticRenderFns } from "./DictationInput.vue?vue&type=template&id=12fdfcf6&scoped=true&"
import script from "./DictationInput.vue?vue&type=script&lang=js&"
export * from "./DictationInput.vue?vue&type=script&lang=js&"
import style0 from "./DictationInput.vue?vue&type=style&index=0&id=12fdfcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fdfcf6",
  null
  
)

export default component.exports